module.exports = __webpack_public_path__ + "assets/img/resolved.9b12fea2.svg";